/* 🤖 this file was generated by svg-to-ts */
export const matIconAppRegistration: {
  name: 'app-registration';
  data: string;
} = {
  name: 'app-registration',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 4h4v4h-4zM4 16h4v4H4zm0-6h4v4H4zm0-6h4v4H4zm12 0h4v4h-4zm-5 13.86V20h2.1l5.98-5.97-2.12-2.12zm3-5.83V10h-4v4h2.03zm6.85-.47-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06c.2-.2.2-.51 0-.71z"/></svg>`
};
